import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RouteMetadata from './seo/RouteMetadata';
import Navbar from './components/Navbar';
import AnalyticsConsent from './components/AnalyticsConsent';
import SiteFooter from './components/SiteFooter';
import styles from './App.module.css';
import { AuthProvider } from './context/AuthContext';

const HomePage = lazy(() => import('./pages/HomePage'));
const ProductsPage = lazy(() => import('./pages/ProductsPage'));
const ProductDetailPage = lazy(() => import('./pages/ProductDetailPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const CredoPage = lazy(() => import('./pages/CredoPage'));
const JoinFamilyPage = lazy(() => import('./pages/JoinFamilyPage'));
const LocalesPage = lazy(() => import('./pages/LocalesPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const ShippingPage = lazy(() => import('./pages/ShippingPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));
const CheckoutPage = lazy(() => import('./pages/CheckoutPage'));
const ITPage = lazy(() => import('./pages/ITPage'));
const CharlaRegistrationPage = lazy(() => import('./pages/CharlaRegistrationPage'));
const AdminCharlasPage = lazy(() => import('./pages/AdminCharlasPage'));

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <div className={styles.App}>
          <RouteMetadata />
          <Navbar />
          <AnalyticsConsent />

          <Suspense fallback={<main className={styles['route-loading']} aria-live="polite">Cargando...</main>}>
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/productos" element={<ProductsPage />} />
            <Route path="/categorias/:category" element={<ProductsPage />} />
            <Route path="/subcategorias/:subcategory" element={<ProductsPage />} />
            <Route path="/promociones" element={<ProductsPage />} />
            <Route path="/sucursales" element={<LocalesPage />} />
            <Route path="/producto/:id" element={<ProductDetailPage />} />

            {/* Rutas de las pÃ¡ginas institucionales */}
            <Route path="/envios" element={<ShippingPage />} />
            <Route path="/locales" element={<LocalesPage />} />
            <Route path="/nosotros" element={<AboutPage />} />
            <Route path="/contacto" element={<ContactPage />} />
            <Route path="/credo" element={<CredoPage />} />
            <Route path="/familia" element={<JoinFamilyPage />} />

            {/* Rutas de AdministraciÃ³n */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/charlas" element={<AdminCharlasPage />} />
            <Route path="/charlas/hablemos-de-nutricion" element={<CharlaRegistrationPage />} />

            {/* Checkout */}
            <Route path="/checkout" element={<CheckoutPage />} />

            {/* IT Diagnostics (Hidden) */}
            <Route path="/it-diagnostics" element={<ITPage />} />
            <Route path="*" element={<main><h1>Pagina no encontrada</h1><a href="/productos">Ver productos</a></main>} />
            </Routes>
          </Suspense>
          <SiteFooter />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
